"use client";

import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { useEffect, useRef, useState } from "react";
import { createCategory } from "../../firebase/categories";
import DialogSuccess from "./DialogSuccess";
import { useAtom } from "jotai";
import { showCreateCategoryModalAtom, userAtom } from "../../store";
import { createCheckouts } from '../../firebase/payments'
import Slider from "react-slick";
import axios from "axios";
import { getAuthHeaders } from "../../firebase/authHeaders";
import { toast } from "react-toastify";
import { useAuth } from "../../context/authContext";

export default function DialogMembership({
    open,
    onClose
}) {
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [preview, setPreview] = useState(null)
    const [categoryName, setCategoryName] = useState(null)
    const [activeNext, setActiveNext] = useState(false)
    const [subCategories, setSubCategories] = useState([])
    const subCategoryRef = useRef(null)
    const [showSuccessDialog, setShowSuccessDialog] = useState(false)
    const [activeTab, setActiveTab] = useState('')
    const [userData, setUserData] = useAtom(userAtom)
    const { membershipsForUser } = useAuth();

    const sliderSettings = {
        dots: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        navigator: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    }

    const handleActivetab = (plan) => {
        if (activeTab === plan) setActiveTab('')
        else setActiveTab(plan)
    }

    const handleNextStep = async () => {
        const price = membershipsForUser[activeTab]?.price;

        if (activeTab !== '') {
            axios({
                method: 'post',
                url: process.env.REACT_APP_PAYMENT_API + '/create-membership-checkout',
                headers: await getAuthHeaders(),
                data: {
                    priceId: membershipsForUser[activeTab]?.priceId,
                    prevLink: window.location.href,
                    customerId: userData.customer_id
                }
            }).then(async ({ data }) => {
                await createCheckouts({ sessionId: data.session.id, sessionLink: data.session.url, checkoutInfo: { type: 'membership', plan: activeTab, user_id: userData.id, price: price } })
                window.location.href = data.session.url;
            })
            .catch((e) => {
                console.error("Error creating checkout session: ", e)
                toast.error(e.message || "Failed to create checkout session")
            })
        }
    }

    return (
        <>
            <DialogSuccess
                message="Category is successfully added"
                open={showSuccessDialog}
                onClose={() => setShowSuccessDialog(false)}
                buttonText="Back to Dashboard"
                title="Success"
                iconSrc="/assets/icons/icon-check-white-circle.svg"
                type="confirm"
            />

            <Dialog open={open} onClose={onClose} className="relative z-[10000]">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-[#000] backdrop-blur-sm bg-opacity-75 transition-opacity"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 sm:p-0">
                        <DialogPanel
                            transition
                            className="flex flex-col relative transform overflow-hidden w-full px-10 h-[100vh] bg-[#141414] backdrop-blur-sm shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in  rounded-[15px]"
                        >
                            <div className="flex justify-between py-6">
                                <button onClick={onClose}>
                                    <img src="/assets/icons/icon-close-white.svg" alt="close" />
                                </button>

                                <button
                                    className={`text-white text-sm font-thin underline ${activeTab === '' || activeTab === userData.membership ? 'opacity-50' : ''}`}
                                    disabled={activeTab === '' || activeTab === userData.membership}
                                    onClick={handleNextStep}
                                >
                                    Next Step
                                </button>
                            </div>
                            <Slider {...sliderSettings} className="w-full max-w-[830px] m-auto membership-slider">
                                <>
                                    <div className={`px-5 py-9 min-h-[350px] bg-[#0d0d0d] text-white ${activeTab === 'basic' ? 'border-style-decoration-active' : 'border-style-decoration'}`}>
                                        <div className="w-fit px-3 py-1 text-[10px] rounded-[12px] text-white bg-primary border-white border-[1px]">
                                            Basic Plan
                                        </div>

                                        <div className="flex items-end mt-6">
                                            <h2 className="uppercase font-bold text-3xl">
                                                ${membershipsForUser['basic'].price}
                                            </h2>
                                            {/* <span className="text-2xl font-medium text-white ml-2 mr-3">
                                                + ${membershipsForUser['basic'].fee}
                                            </span> */}
                                            <span className="text-base"> /month</span>
                                        </div>

                                        <div className="flex gap-y-4 flex-col mt-10">
                                            {
                                                membershipsForUser['basic'].benefits.map((item, index) =>
                                                    <div className="w-full flex" key={`${item}-${index}`}>
                                                        <img
                                                            alt="circle"
                                                            src="/assets/icons/icon-check-circle.svg"
                                                            className="w-full mr-2 max-w-[18px]"
                                                        />
                                                        <span className="text-xs">
                                                            {item}
                                                        </span>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>

                                    <button
                                        className={`border-[1px] text-white py-3 w-full mt-4 text-xs ${activeTab === 'basic' ? 'border-primary' : 'border-gray'} ${userData.membership === 'basic' ? 'bg-primary border-primary' : ''}`}
                                        onClick={() => handleActivetab('basic')}
                                    >
                                        {
                                            userData.membership === 'basic' && 'Current Plan'
                                        }
                                        {
                                            userData.membership === 'free' && 'Select Plan'
                                        }
                                        {
                                            userData.membership === 'pro' || userData.membership === 'elite' ? 'Downgrade Plan' : ''
                                        }
                                    </button>
                                </>

                                <>
                                    <div className={`px-5 py-9 min-h-[350px] bg-[#0d0d0d] text-white ${activeTab === 'pro' || userData.membership === 'pro' ? 'border-style-decoration-active' : 'border-style-decoration'}`}>
                                        <div className="w-fit px-3 py-1 text-[10px] rounded-[12px] text-white bg-primary border-white border-[1px]">
                                            Pro Plan
                                        </div>

                                        <div className="flex items-end mt-6">
                                            <h2 className="uppercase font-bold text-3xl">${membershipsForUser['pro'].price}</h2>
                                            {/* <span className="text-2xl font-medium text-white ml-2 mr-3">
                                                + ${membershipsForUser['pro'].fee}
                                            </span> */}
                                            <span className="text-base"> /month</span>
                                        </div>

                                        <div className="flex gap-y-4 flex-col mt-10">
                                            {
                                                membershipsForUser['pro'].benefits.map((item, index) =>
                                                    <div className="w-full flex" key={`${item}-${index}`}>
                                                        <img
                                                            alt="circle"
                                                            src="/assets/icons/icon-check-circle.svg"
                                                            className="w-full mr-2 max-w-[18px]"
                                                        />
                                                        <span className="text-xs">
                                                            {item}
                                                        </span>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>

                                    <button
                                        className={`border-[1px] text-white py-3 w-full mt-4 text-xs ${activeTab === 'pro' ? 'border-primary' : 'border-gray'} ${userData.membership === 'pro' ? 'bg-primary border-primary' : ''}`}
                                        onClick={() => handleActivetab('pro')}
                                    >
                                        {
                                            userData.membership === 'pro' && 'Current Plan'
                                        }
                                        {
                                            userData.membership === 'free' && 'Select Plan'
                                        }
                                        {
                                            userData.membership === 'basic' && 'Upgrade Plan'
                                        }
                                        {
                                            userData.membership === 'elite' && 'Downgrade Plan'
                                        }
                                    </button>
                                </>

                                <>
                                    <div className={`px-5 py-9 min-h-[350px] bg-[#0d0d0d] text-white ${activeTab === 'elite' ? 'border-style-decoration-active' : 'border-style-decoration'}`}>
                                        <div className="w-fit px-3 py-1 text-[10px] rounded-[12px] text-white bg-primary border-white border-[1px]">
                                            Elite Plan
                                        </div>

                                        <div className="flex items-end mt-6">
                                            <h2 className="uppercase font-bold text-3xl">${membershipsForUser['elite'].price}</h2>
                                            {/* <span className="text-2xl font-medium text-white ml-2 mr-3">
                                                + ${membershipsForUser['elite'].fee}   
                                            </span> */}
                                            <span className="text-base"> /month</span>
                                        </div>

                                        <div className="flex gap-y-4 flex-col mt-10">
                                            {
                                                membershipsForUser['elite'].benefits.map((item, index) =>
                                                    <div className="w-full flex" key={`${item}-${index}`}>
                                                        <img
                                                            alt="circle"
                                                            src="/assets/icons/icon-check-circle.svg"
                                                            className="w-full mr-2 max-w-[18px]"
                                                        />
                                                        <span className="text-xs">
                                                            {item}
                                                        </span>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>


                                    <button
                                        className={`border-[1px] text-white py-3 w-full mt-4 text-xs ${activeTab === 'elite' ? 'border-primary' : 'border-gray'} ${userData.membership === 'elite' ? 'bg-primary border-primary' : ''}`}
                                        onClick={() => handleActivetab('elite')}
                                    >
                                        {
                                            userData.membership === 'elite' && 'Current Plan'
                                        }
                                        {
                                            userData.membership === 'free' && 'Select Plan'
                                        }
                                        {
                                            userData.membership === 'pro' || userData.membership === 'basic' ? 'Upgrade Plan' : ''
                                        }
                                    </button>
                                </>
                            </Slider>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    );
}
